import { THttpService } from '@/services/HttpService';

import { TInteractionType, TInteractionData } from './types';

import { setInteraction } from '.';

export async function dispatchInteraction(
  api: THttpService,
  type: TInteractionType,
  params: TInteractionData,
): Promise<void> {
  const callBacks = {
    extra_mpv_ruler_select_miles_value: () => {
      setInteraction(api, 'extra_mpv_ruler_select_miles_value', params);
    },
    extra_mpv_ruler_click_other_voucher: () => {
      setInteraction(api, 'extra_mpv_ruler_click_other_voucher', params);
    },
    extra_mpv_ruler_click_rules: () => {
      setInteraction(api, 'extra_mpv_ruler_click_rules', params);
    },
    extra_mpv_ruler_click_continue: () => {
      setInteraction(api, 'extra_mpv_ruler_click_continue', params);
    },
    extra_mpv_ruler_click_close: () => {
      setInteraction(api, 'extra_mpv_ruler_click_close', params);
    },
    extra_mpv_value_select_miles_value: () => {
      setInteraction(api, 'extra_mpv_value_select_miles_value', params);
    },
    extra_mpv_value_click_other_voucher: () => {
      setInteraction(api, 'extra_mpv_value_click_other_voucher', params);
    },
    extra_mpv_value_click_rules: () => {
      setInteraction(api, 'extra_mpv_value_click_rules', params);
    },
    extra_mpv_value_click_continue: () => {
      setInteraction(api, 'extra_mpv_value_click_continue', params);
    },
    extra_mpv_value_click_back: () => {
      setInteraction(api, 'extra_mpv_value_click_back', params);
    },
    extra_mpv_rules_click_back: () => {
      setInteraction(api, 'extra_mpv_rules_click_back', params);
    },
    extra_mpv_select_voucher_click_voucher: () => {
      setInteraction(api, 'extra_mpv_select_voucher_click_voucher', params);
    },
    extra_mpv_select_voucher_click_back: () => {
      setInteraction(api, 'extra_mpv_select_voucher_click_back', params);
    },
    extra_mpv_summary_click_other_voucher: () => {
      setInteraction(api, 'extra_mpv_summary_click_other_voucher', params);
    },
    extra_mpv_summary_click_rules: () => {
      setInteraction(api, 'extra_mpv_summary_click_rules', params);
    },
    extra_mpv_summary_click_checkout: () => {
      setInteraction(api, 'extra_mpv_summary_click_checkout', params);
    },
    extra_mpv_summary_click_back: () => {
      setInteraction(api, 'extra_mpv_summary_click_back', params);
    },
    extra_mpv_ruler_click_change: () => {
      setInteraction(api, 'extra_mpv_ruler_click_change', params);
    },
    extra_vs_voucher_select_click_miles_purchase: () => {
      setInteraction(
        api,
        'extra_vs_voucher_select_click_miles_purchase',
        params,
      );
    },
    extra_vs_voucher_select_click_airline: () => {
      setInteraction(api, 'extra_vs_voucher_select_click_airline', params);
    },
    extra_vs_voucher_select_click_close: () => {
      setInteraction(api, 'extra_vs_voucher_select_click_close', params);
    },
    extra_av_rules_click_close: () => {
      setInteraction(api, 'extra_av_rules_click_close', params);
    },
  };

  callBacks[type]();
}
